import type { SiteFeatures } from '../types/site'

/** Zonder instelling (oude server, lokale data) staat alles aan, zoals de site altijd was. */
export const DEFAULT_FEATURES: Readonly<SiteFeatures> = Object.freeze({
  diary: true,
  subscriptions: true,
  analytics: true,
  acquisitionQuestion: true,
  weeklySummary: true,
  prepaidKuur: true,
})

const KEYS = Object.keys(DEFAULT_FEATURES) as (keyof SiteFeatures)[]

/**
 * Eén regel voor het uitlezen van `SiteSettings.features`: alleen een echte `false` zet iets uit.
 * Een ontbrekend veld, `null` of een vreemde waarde valt terug op aan.
 */
export function resolveFeatures(raw: unknown): SiteFeatures {
  const r = raw && typeof raw === 'object' ? (raw as Partial<Record<keyof SiteFeatures, unknown>>) : {}
  return Object.fromEntries(KEYS.map((k) => [k, r[k] !== false])) as SiteFeatures
}

/** Zelfde stand? (Voor het live store: alleen seinen bij een echte wijziging.) */
export const sameFeatures = (a: SiteFeatures, b: SiteFeatures) => KEYS.every((k) => a[k] === b[k])

/** Kan dit product in het Bewust Abonnement? Product én onderdeel moeten het toestaan. */
export const canSubscribe = (features: Pick<SiteFeatures, 'subscriptions'>, product: { refill: boolean }) => features.subscriptions && product.refill
